export const MuiSvgIcon = {
  styleOverrides: {
    root: {
      fontSize: '24px',
    },
  },
};
